<i18n src="./resources/locales.json"></i18n>
<template>
  <v-hover v-slot:default="{ hover }" :style="THEME_CSS_VARS">
    <v-list-item @click="openConversation" ripple dense class="conversation-item" :class="{'conversation-item-selected': isActiveConversation(conversation)}">
      <v-badge
        v-if="conversation.unreadMessages"
        class="count-messages sms-primary-area"
        :content="conversation.unreadMessages"
      />

      <v-list-item-avatar class="mr-2">
        <v-menu
          :open-on-hover="!$vuetify.breakpoint.mobile"
          bottom offset-y
          :z-index="1000"
          :close-on-content-click="$vuetify.breakpoint.mobile">
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <SmsAvatar :contact="conversation.contact" />
            </div>
          </template>
          <SmsContactCard :contact="conversation.contact" :conversation="conversation" />
        </v-menu>
      </v-list-item-avatar>

      <v-list-item-content @contextmenu.prevent="displayActionsContextMenuForMobile($event)">
        <v-list-item-title
          v-html="conversationDisplayName"
          class="conversation-item-title"
          :class="{'font-weight-black':conversation.unreadMessages}"
        />
        <v-list-item-subtitle
          v-if="(conversation.newestMessage || {}).body"
          v-html="(conversation.newestMessage || {}).body"
          class="conversation-item-subtitle"
          :class="{'font-weight-black':conversation.unreadMessages}"
        />
        <v-list-item-icon
          v-else
          class="list-icon">
          <v-icon size="15">{{icon}}</v-icon>
          <span class="sms-contact-subtitle">{{attachmentText}}</span>
        </v-list-item-icon>
      </v-list-item-content>

      <v-list-item-action v-show="!hover || !(hover && conversationActions.length)" class="timestamp">
        {{ lastMessageTimeMessage }}
      </v-list-item-action>

      <v-list-item-action
        v-if="!$vuetify.breakpoint.mobile && (hover || menu) && conversationActions.length"
        class="actions-menu"
      >
        <v-menu offset-x>
          <template v-slot:activator="{ on }">
            <v-btn v-if="!$vuetify.breakpoint.mobile" v-on="on" width="32" height="32" icon @click.stop="menu = true">
              <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="action in conversationActions"
              :key="action.label"
              @click.stop="() => { action.action(); menu = false; }"
            >
              {{ action.label }}
            </v-list-item>
          </v-list>
        </v-menu>
      </v-list-item-action>
    </v-list-item>

  </v-hover>

</template>

<script>
import { mapActions } from 'vuex';
import ThemeMixin from '@/mixins/ThemeMixin';
import TimeFormatMixin from '@/mixins/TimeFormatMixin';
import SmsAvatar from '@/components/SmsAvatar/SmsAvatar';
import SmsContactCard from '@/components/SmsContactCard/SmsContactCard';
import ToastMixin from '@/mixins/ToastMixin.js';
import store from '@/store';

export default {
  name: 'SmsConversationItem',

  components: { SmsAvatar, SmsContactCard },

  mixins: [TimeFormatMixin, ThemeMixin, ToastMixin],

  data() {
    return {
      menu: false,
      countNewMessage: 0,
    };
  },

  props: {
    conversation: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },

  computed: {
    lastMessageTimeMessage() {
      let lastMessageTimeMessage = '';
      if (this.conversation.newestMessage.originationTime) {
        const lastMessageDateTime = this.$moment(this.conversation.newestMessage.originationTime);
        if (this.$moment().diff(lastMessageDateTime, 'hours') < 24) {
          lastMessageTimeMessage = this.applyTimeFormat(lastMessageDateTime, true);
        } else if (this.$moment().diff(lastMessageDateTime, 'days') < 365) {
          lastMessageTimeMessage = lastMessageDateTime.format('M/D');
        } else {
          lastMessageTimeMessage = lastMessageDateTime.format('M/D/YYYY');
        }
      }
      return lastMessageTimeMessage;
    },

    conversationDisplayName() {
      return this.conversation.getConversationDisplayName();
    },

    conversationActions() {
      const actions = [];
      if (!this.conversation.isGroupConversation && this.isAnonymousConversation && !this.conversation.contact.isCurrentAgentContact) {
        actions.push({
          label: this.$t('conversationItem.addToContacts'),
          action: this.addToContacts
        });
      }

      //TODO: hide delete conversation for now, but need to fix this in the future
      // actions.push({
      //   label: this.$t('conversationItem.deleteConversation'),
      //   action: this.deleteConversation
      // });

      return actions;
    },

    isAnonymousConversation() {
      return !this.conversation.contact.fullName;
    },

    hasNewMessage() {
      return this.getNotifications.length > 0;
    },
    icon() {
      return this.conversation.newestMessage.attachments &&
             this.conversation.newestMessage.attachments[0].isVCF ?
             'mdi-card-account-phone' : 'mdi-camera';
    },
    attachmentText() {
      return this.conversation.newestMessage.attachments &&
             this.conversation.newestMessage.attachments[0].isVCF ?
             this.$t('conversationItem.attachmentVCFText') : this.$t('conversationItem.attachmentImageText');
    }
  },

  methods: {
    ...mapActions('conversationsV2', ['setActiveConversationId']),

    addToContacts() {
      this.$root.$emit('open-contact-dialog', { number: this.conversation.contact.number });
    },

    isActiveConversation(conversation) {
      const activeConversationId = store.getters['conversationsV2/activeConversationId'];
      return (conversation.groupMessageKey || conversation.contactNumber) === activeConversationId;
    },

    deleteConversation() {
      this.$emit('delete-conversation', this.conversation);
    },

    openConversation() {
      this.$root.$emit('close-sidebar');
      this.setActiveConversationId(this.conversation.conversationId);
    },

    displayActionsContextMenuForMobile(event) {
      if (this.$vuetify.breakpoint.mobile && this.conversationActions.length) {
        this.$root.$emit('open-context-menu', {
          actions: this.conversationActions,
          positionX: event.clientX,
          positionY: event.clientY
        });
      }
    }
  }
};
</script>

<style>
.conversation-item {
  height: 50px;
  padding: 0 8px;
}
.conversation-item-selected {
  background: #ededed;
}
.conversation-item-title,
.conversation-item-subtitle {
  font-weight: normal !important;
}
.conversation-item-subtitle {
  font-size: 13px !important;
}
.conversation-item .timestamp {
  font-size: 12px;
  margin-right: 4px;
}
.conversation-item .actions-menu {
  margin-left: 8px;
}
.conversation-item .count-messages {
  position: absolute;
  top: 20px;
  left: 40px;
  z-index: 1;
}
.conversation-item .count-messages .v-badge__badge{
  font-size: 10px;
  min-width: 18px;
  min-height: 18px;
  line-height: 18px;
  padding: 0 4px;
  height: 18px;
  border: 1px solid var(--v-surface-base);
  border-color: var(--v-surface-base) !important;
  text-align: center;
}
.list-icon{
  margin: 0 !important;
  max-height: 15.56px;
  font-size: 13px;
  color: rgb(0, 0, 0, 0.6);
}
.list-icon > span{
  margin-left: 5px;
}
.list-icon > i{
  margin-top: 3px;
}
.sms-contact-subtitle {
  font-size: 0.8rem !important;
  color: var(--icon-text-font-color) !important;
}
</style>
